import "./chunk-4AFQP74Z.js";

// src/date.ts
var SECOND = 1e3;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
var dateUtcTime = (date) => {
  const timezoneOffset = date.getTimezoneOffset() * MINUTE;
  return date.getTime() + timezoneOffset;
};
var getTimediffSplitDHMS = (d1, d2) => {
  const millisecondsLeft = dateUtcTime(d1) - dateUtcTime(d2);
  return {
    days: Math.floor(millisecondsLeft / DAY),
    hours: Math.floor(millisecondsLeft % DAY / HOUR),
    minutes: Math.floor(millisecondsLeft % HOUR / MINUTE),
    seconds: Math.floor(millisecondsLeft % MINUTE / SECOND)
  };
};
var getTimediffSplitHMS = (d1, d2) => {
  const millisecondsLeft = dateUtcTime(d1) - dateUtcTime(d2);
  return {
    hours: Math.floor(millisecondsLeft / HOUR),
    minutes: Math.floor(millisecondsLeft % HOUR / MINUTE),
    seconds: Math.floor(millisecondsLeft % MINUTE / SECOND)
  };
};
export {
  DAY,
  HOUR,
  MINUTE,
  SECOND,
  dateUtcTime,
  getTimediffSplitDHMS,
  getTimediffSplitHMS
};
